var _ellipse, _ellipse2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIllustrationQuestionMark = function SvgIllustrationQuestionMark(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94 93",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.1,
    cy: 65.4,
    fill: "var(--secondary-fill)",
    rx: 14.4,
    ry: 14.5,
    transform: "rotate(-90 64 65.4)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.8,
    cy: 27.5,
    fill: "var(--secondary-fill)",
    rx: 14.4,
    ry: 14.5,
    transform: "rotate(-90 29.8 27.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--secondary-fill)",
    d: "m70.062 31.851 1.165-9.63 9.731 1.161-1.165 9.63zM12.943 71.413l2.149-9.459 9.567 2.121-2.149 9.459z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M47.782 24.704c-12.723 0-23.073 10.05-23.073 22.406s10.35 22.405 23.073 22.405 23.074-10.05 23.074-22.405-10.35-22.406-23.074-22.406"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-white)",
    d: "M47.745 53.092q.528 0 .895-.362.364-.36.364-.884t-.364-.885a1.22 1.22 0 0 0-.895-.362q-.53 0-.895.362-.365.36-.365.885 0 .523.365.884.366.362.895.362m.15-10.27q.707.001 1.135.386.428.387.428 1.01 0 .425-.29.86a5 5 0 0 1-.819.91q-.755.649-1.108 1.246-.353.6-.353 1.197 0 .35.265.585a.9.9 0 0 0 .617.237.92.92 0 0 0 .63-.249q.276-.25.352-.623.075-.423.341-.785.264-.361.869-.935.78-.723 1.096-1.32.315-.6.315-1.322 0-1.27-.97-2.082-.97-.81-2.507-.81-1.059 0-1.876.4-.82.398-1.273 1.22a.98.98 0 0 0-.126.636q.05.312.352.511a.98.98 0 0 0 .719.125q.39-.075.642-.424.277-.373.668-.573.39-.2.894-.2m-.1 14.258a9.8 9.8 0 0 1-3.905-.786 10.3 10.3 0 0 1-3.212-2.13 10 10 0 0 1-2.166-3.166 9.6 9.6 0 0 1-.794-3.888q0-2.069.794-3.889a10 10 0 0 1 2.166-3.165 10.3 10.3 0 0 1 3.212-2.132 9.85 9.85 0 0 1 3.905-.784q2.117 0 3.956.784a10.2 10.2 0 0 1 3.199 2.132 9.9 9.9 0 0 1 2.142 3.165q.78 1.82.78 3.889t-.78 3.888a9.9 9.9 0 0 1-2.142 3.166 10.2 10.2 0 0 1-3.2 2.13q-1.839.786-3.955.786"
  })));
};
export default SvgIllustrationQuestionMark;